import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function AboutHosts() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-24 md:py-32 bg-white relative overflow-hidden" data-id="element-3">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 bg-pattern-kente opacity-[0.03] pointer-events-none" data-id="element-4" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 flex flex-col items-center text-center" data-id="element-5">
        {/* Eyebrow */}
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-mono text-earth-terracotta text-sm tracking-widest uppercase mb-12 block font-bold" data-id="element-6">
          {t('about.eyebrow')}
        </motion.span>

        {/* Main Prose */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-10 mb-16" data-id="element-7">
          <p className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal-900 leading-tight" data-id="element-8">
            {t('about.p1')}
          </p>
          <p className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal-900 leading-tight" data-id="element-9">
            {t('about.p2.start')}
            <span className="text-charcoal-400" data-id="element-10">{t('about.p2.muted')}</span>
          </p>
        </motion.div>

        {/* Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-24" data-id="element-11">
          <button className="border-2 border-charcoal-900 text-charcoal-900 px-8 py-3 rounded-full font-sans font-bold tracking-wide hover:bg-charcoal-900 hover:text-white transition-colors duration-300" data-id="element-12">
            {t('about.button')}
          </button>
        </motion.div>

        {/* Portrait */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="w-full max-w-4xl mx-auto" data-id="element-13">
          <div className="group aspect-[16/10] md:aspect-[2/1] overflow-hidden relative shadow-2xl rounded-lg mb-8" data-id="element-14">
            <img src="https://cdn.magicpatterns.com/uploads/p3V2PWZKbyZhorU3QCJYeF/IMG_3365.jpg" alt="The Hosts" className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-15" />
            {/* Brand color duotone layer */}
            <div className="absolute inset-0 bg-gradient-to-tr from-earth-terracotta via-gold to-earth-ochre mix-blend-color opacity-75 group-hover:opacity-0 transition-opacity duration-700 pointer-events-none" data-id="element-16" />
            {/* Subtle kente texture */}
            <div className="absolute inset-0 bg-pattern-kente opacity-20 group-hover:opacity-0 transition-opacity duration-700 pointer-events-none" data-id="element-17" />
            {/* Gold edge accent */}
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/30 rounded-lg pointer-events-none" data-id="element-18" />
          </div>

          {/* Host Names & Roles */}
          <div className="grid grid-cols-2 gap-8 text-center border-t border-charcoal-200 pt-8" data-id="element-19">
            <div data-id="element-20">
              <h3 className="font-serif text-2xl font-bold text-charcoal-900 mb-1" data-id="element-21">
                {t('about.host1.name')}
              </h3>
              <p className="font-mono text-sm text-earth-terracotta uppercase tracking-widest font-bold" data-id="element-22">
                {t('about.host1.role')}
              </p>
            </div>
            <div data-id="element-23">
              <h3 className="font-serif text-2xl font-bold text-charcoal-900 mb-1" data-id="element-24">
                {t('about.host2.name')}
              </h3>
              <p className="font-mono text-sm text-earth-terracotta uppercase tracking-widest font-bold" data-id="element-25">
                {t('about.host2.role')}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}